import React, { useState, useEffect } from 'react';
import { silentWisdomAccount } from '../chain';

const Web3Login = ({ onConnect }) => {
  const [account, setAccount] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    silentWisdomAccount()
      .then((address) => {
        if (address) {
          setAccount(address);
        }
      })
      .catch((err) => {
        setError("Failed to connect wallet");
        console.error(err);
      });
  }, []);

  return (
    <div>
    </div>
  );
};

export default Web3Login;
